// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"bf8f48c9","268":"2e725fa3","293":"90bdb4ee","326":"263a5710","456":"cdc9ad09","520":"4c2b5ef1","534":"1b427e5f","664":"c033fda0","680":"0f24693a","743":"5b6d269b","796":"e26b62a3","829":"bd03efdd","854":"eafef090","912":"b894d464"}[chunkId] + ".chunk.js";
};